module.exports = __webpack_public_path__ + "images/Monetize_Diagram_2x-d40336fea4a3775703f2c6dda747224b.png";